export enum WebCashPermissionKeys {
  WebCxCash = 'WebCxCash',
  WebCxCashCancelTicket = 'WebCxCashCancelTicket',
  WebCxCashCancelConcession = 'WebCxCashCancelConcession',
  WebCxCashSafes = 'WebCxCashSafes',
  WebCxCashSessionStatistics = 'WebCxCashSessionStatistics',
  WebCxCashChangeCinema = 'WebCxCashChangeCinema',
  WebCxCashCardExchangeWithoutFee = 'WebCxCashCardExchangeWithoutFee',
  WebCxCashCardWithdraw = 'WebCxCashCardWithdraw',
  WebCxCashCardCancel = 'WebCxCashCardCancel',
  WebCxCashGiveDiscountRange1 = 'WebCxCashGiveDiscountRange1',
  WebCxCashGiveDiscountRange2 = 'WebCxCashGiveDiscountRange2',
  WebCxCashOnlineOrders = 'WebCxCashOnlineOrders'
}